export default __webpack_public_path__ + "static/media/Snd_TryE.0305e771.mp3";